import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (isMobile) setCollapsed(true);
  }, [isMobile]);

  return (
    <Box sx={{ display: 'flex', width: '100%', overflowX: 'hidden' }}>
      <Sidebar collapsed={collapsed} />

      {/* minWidth: 0 lets wide tables scroll inside their own container
          instead of stretching the whole page on phones/tablets */}
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Header collapsed={collapsed} setCollapsed={setCollapsed} />

        <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;